import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const EventAiModalApi = createApi({
  reducerPath: "eventAiModalApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    EventMetadata: builder.mutation({
      query: (data) => {
        return {
          url: `/cmetadata`,
          method: "POST",
          body: data
        };
      },
      extraOptions: { service: "Metadata_Generator" }
    })
  })
});

export const { useEventMetadataMutation } = EventAiModalApi;
